import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Progress} from 'kpc';

var _$tmp0 = {
    'percent': '50'
};
var _$tmp1 = {
    'percent': '100'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Progress, _$tmp0),
        _$cc(Progress, _$tmp1)
    ], 4 /* HasNonKeyedChildren */);
};